export default "__VITE_ASSET__DSZ1MKcD__"